import { render, staticRenderFns } from "./RealList.vue?vue&type=template&id=51a9851c"
import script from "./RealList.vue?vue&type=script&lang=js"
export * from "./RealList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports